
import { importSync as i, macroCondition, getGlobalConfig } from '@embroider/macros';
let w = window;
let d = w.define;


i("./-embroider-implicit-modules.js");

d("photodiode/app", function(){ return i("photodiode/app.js");});
d("photodiode/config/environment", function(){ return i("photodiode/config/environment.js");});
d("photodiode/deprecation-workflow", function(){ return i("photodiode/deprecation-workflow.js");});
d("photodiode/formats", function(){ return i("photodiode/formats.js");});
d("photodiode/router", function(){ return i("photodiode/router.ts");});
d("photodiode/services/cdp", function(){ return i("photodiode/services/cdp.ts");});
d("photodiode/services/data", function(){ return i("photodiode/services/data.ts");});
d("photodiode/services/help-text", function(){ return i("photodiode/services/help-text.ts");});
d("photodiode/services/logger", function(){ return i("photodiode/services/logger.ts");});
d("photodiode/services/model", function(){ return i("photodiode/services/model.ts");});
d("photodiode/services/opamp", function(){ return i("photodiode/services/opamp.ts");});
d("photodiode/services/persistence", function(){ return i("photodiode/services/persistence.ts");});
d("photodiode/services/sensor", function(){ return i("photodiode/services/sensor.ts");});
d("photodiode/services/snapshot", function(){ return i("photodiode/services/snapshot.ts");});
d("photodiode/services/svg-cache", function(){ return i("photodiode/services/svg-cache.ts");});
d("photodiode/services/toolsapi", function(){ return i("photodiode/services/toolsapi.ts");});
d("photodiode/utils/analytics", function(){ return i("photodiode/utils/analytics.ts");});
d("photodiode/utils/design-files", function(){ return i("photodiode/utils/design-files.ts");});
d("photodiode/utils/download", function(){ return i("photodiode/utils/download.ts");});
d("photodiode/utils/spice-netlist", function(){ return i("photodiode/utils/spice-netlist.ts");});
d("photodiode/utils/spice-schematics", function(){ return i("photodiode/utils/spice-schematics.ts");});
d("photodiode/services/aditools-analytics", function(){ return i("photodiode/services/aditools-analytics.js");});
d("photodiode/services/aditools-site", function(){ return i("photodiode/services/aditools-site.js");});
d("photodiode/services/intl", function(){ return i("photodiode/services/intl.js");});
d("photodiode/services/page-title", function(){ return i("photodiode/services/page-title.js");});
d("photodiode/instance-initializers/load-translations", function(){ return i("photodiode/instance-initializers/load-translations.js");});
d("photodiode/initializers/app-version", function(){ return i("photodiode/initializers/app-version.js");});
d("photodiode/templates/application", function(){ return i("photodiode/templates/application.hbs");});
d("photodiode/controllers/application", function(){ return i("photodiode/controllers/application.ts");});
d("photodiode/routes/application", function(){ return i("photodiode/routes/application.ts");});
d("photodiode/templates/photodiode", function(){ return i("photodiode/templates/photodiode.hbs");});
d("photodiode/controllers/photodiode", function(){ return i("photodiode/controllers/photodiode.ts");});
d("photodiode/routes/photodiode", function(){ return i("photodiode/routes/photodiode.ts");});
d("photodiode/routes/index", function(){ return i("photodiode/routes/index.ts");});



w._embroiderRouteBundles_ = [
  {
    names: ["circuit"],
    load: function() {
      return import("photodiode/assets/_route_/circuit.js");
    }
  },
  {
    names: ["nextsteps"],
    load: function() {
      return import("photodiode/assets/_route_/nextsteps.js");
    }
  },
]


if (!runningTests) {
  i("../app").default.create({"name":"photodiode","version":"2.24.2+1f5ab8d2"});
}

